module.exports = __webpack_public_path__ + "img/weddingbands.79a57e9.jpg";